import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 72,
    height: 'auto',
    display: 'block',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 600 341"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75.3183 120.54C90.9065 120.54 104.168 124.162 115.785 135.064L138.336 108.627C119.442 92.1175 100.197 87.172 74.6534 87.172C44.7883 87.172 5.65164 100.391 5.65164 138.024C5.65164 175.014 42.4797 186.229 73.3236 188.545C96.5397 189.869 105.83 194.483 105.83 205.716C105.83 217.611 91.5529 225.535 76.2972 225.204C58.0494 224.873 31.5273 215.295 19.91 202.426L0 231.161C23.881 255.943 49.7566 260.227 75.6323 260.227C122.415 260.227 145.964 235.463 145.964 206.728C145.964 163.468 106.809 156.537 75.9647 154.552C55.0758 153.228 45.4532 147.29 45.4532 136.719C45.4532 126.478 56.0732 120.54 75.3183 120.54Z"
        fill="#00B7CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M261.009 260.32C314.256 260.32 344.916 222.08 344.916 173.784C344.916 125.156 310.876 87.2472 259.661 87.2472C240.785 87.2472 218.548 95.2996 205.748 113.739L203.052 90.9241H164.636V289.883C176.678 302.09 190.511 312.515 205.748 320.732V236.825C217.532 254.952 243.481 260.32 261.009 260.32ZM256.613 126.829C286.257 126.829 303.784 147.953 303.784 173.784C303.784 199.614 284.576 220.738 256.613 220.738C228.651 220.738 209.442 199.614 209.442 173.784C209.442 147.953 226.97 126.829 256.613 126.829Z"
        fill="#00B7CF"
      />
      <path
        d="M368.666 87.2472H409.779V173.701V260.155H368.666V87.2472Z"
        fill="#00B7CF"
      />
      <path
        d="M558.869 168.838V260.155H600V168.507C600 116.516 568.657 87.3391 529.576 87.3391C508.669 87.3391 491.825 95.7225 474.981 112.158L472.265 87.2472H435.53V260.155H476.31V170.861C476.31 145.692 493.505 124.568 518.771 124.568C545.053 124.568 558.869 143.688 558.869 168.838Z"
        fill="#00B7CF"
      />
      <path
        d="M366.86 13.0631C364.699 14.2765 362.667 15.6921 360.802 17.31C355.593 21.8694 351.992 27.8812 350.292 34.6835C345.601 32.1832 340.762 29.9403 335.775 27.9915C326.781 24.4616 317.361 21.7959 307.684 20.1045L305.874 19.7735C305.569 19.7276 305.264 19.6862 304.959 19.6449C304.655 19.6035 304.35 19.5621 304.045 19.5162L300.388 19.0198C299.33 18.8442 298.272 18.7518 297.202 18.6583C297.039 18.6441 296.876 18.6299 296.713 18.6153L293.019 18.2844C288.087 18.027 283.101 17.7696 278.132 17.9718C268.177 18.2476 258.186 19.4978 248.36 21.7591C238.516 24.002 228.893 27.3848 219.621 31.6684C201.078 40.2357 184.031 52.6821 169.957 68.1988C181.944 51.0275 197.55 36.0624 215.761 24.6271C224.867 18.9278 234.6 14.0191 244.832 10.2687C255.046 6.48142 265.721 3.72372 276.618 2.01395C282.066 1.09472 287.57 0.653485 293.111 0.249022L297.267 0.0835599C297.61 0.0744443 297.955 0.0630689 298.3 0.0516747C299.347 0.0171079 300.399 -0.0176326 301.441 0.0100212L305.615 0.0467905C305.959 0.0560433 306.307 0.0606393 306.658 0.0652659C307.005 0.069832 307.353 0.074428 307.702 0.0835599L309.789 0.193868C320.945 0.708639 332.119 2.34487 343.089 5.10257C351.179 7.12489 359.121 9.79066 366.86 13.0631Z"
        fill="#FF6002"
      />
      <path
        d="M389.976 20.2341C388.96 20.2341 387.926 20.2892 386.91 20.4179C376.66 21.5578 367.148 28.4704 365.855 41.1558C365.763 42.1118 365.707 43.123 365.707 44.1525C365.707 60.092 377.842 68.0526 389.976 68.0526C402.11 68.0526 414.245 60.092 414.245 44.1525C414.245 28.1946 402.11 20.2341 389.976 20.2341Z"
        fill="#FF6002"
      />
      <path
        d="M357.163 314.572C338.62 321.577 318.95 324.758 299.649 324.132C280.33 323.563 261.436 319.169 244.333 311.465C235.117 307.329 226.436 302.218 218.439 296.335V327.681C224.183 330.126 230.038 332.259 235.985 334.023C256.985 340.329 278.982 342.333 300.259 340.146C321.536 338.013 342.147 331.725 360.525 321.853C378.92 311.999 395.062 298.633 407.917 282.932C393.086 296.813 375.706 307.586 357.163 314.572Z"
        fill="#FF6002"
      />
    </svg>
  );
};

export default LogoFull;
